module.exports = __webpack_public_path__ + "static/parade-2020-house19-5ab15e1229fcbd89a397880ad9feb649.jpg";